import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'stickyNav',
  title: 'Sticky Navigation Item',
  type: 'object',
  fields: [
    defineField({
      title: 'Label',
      name: 'label',
      type: 'string',
    }),
  ],
  preview: {
    select: {
      label: 'label',
    },
    prepare({ label }) {
      return {
        title: label,
        subtitle: 'Sticky Navigation Item',
      }
    },
  },
})